<script>
  export let createRec;
import { Badge, Table, Button } from "sveltestrap";


</script>


<div class="row pt-2">
  <div class="col-sm">

  <Button on:click={createRec}>Create</Button>
</div>
</div>
<div class="row pt-2">
  <div class="col-sm">
    <Table>
    <tr>
      <td>Rec</td>
      <td>Owner</td>
      <td>Last Run By</td>
      <td>Data sets</td>
      <td>Status</td>
      <td>Action</td>
    </tr>
    <tr>
      <td>AccountsRec</td>
      <td><a href="#rec">Jimmy Blue</a></td>
      <td><a href="#rec">Sarah Red</a></td>
      <td>
        <a href="#rec">Metropolis Bank Acc</a>
        <br>
        <a href="#rec">Accounts receivable UK</a>
      </td>
      <td>
        <Badge>34</Badge>
        <Badge>234</Badge>
        <Badge>1</Badge>
      </td>
      <td>
        <Button>Open</Button>
        <Button>Remove</Button>
      </td>
    </tr>
  </Table>
</div>
</div>
